import React, { useState } from 'react';
import {
  StepContainer,
  StepLabelContainer,
  StepPrimaryLabel,
  StepIcon,
  Step,
  StepConnector,
  StepProgressBar,
  StepWrapper,
  StepContent,
} from 'cdk-radial';
import './DAABSubscriptions.scss';
import { StepperFooter } from './AddLocationsStepperFooter';
import { DAAB_ADD_LOCATIONS_STEPS } from '../../utils/daabSubscriptions';
import { LocationsTable } from './LocationsTable';
import { SelectDMS } from './SelectDMS';
import ReviewActivations from './ReviewActivations';

export const AddLocationsStepper = ({
  selectedAPI,
  apiNeedsDMS,
  handleLocationSelection,
  handleCompleteActivation,
  bundleLocations,
  bundleId,
  activeSubByEntityId,
}) => {
  const [activeStep, setActiveStep] = useState(1);
  const steps = [
    {
      label: DAAB_ADD_LOCATIONS_STEPS.SELECT_LOCATION,
    },
    ...(apiNeedsDMS
      ? [
          {
            label: DAAB_ADD_LOCATIONS_STEPS.SELECT_DMS,
          },
        ]
      : []),
    {
      label: DAAB_ADD_LOCATIONS_STEPS.REVIEW_ACTIVATION,
    },
  ];

  return (
    <div>
      <StepContainer
        className="daab-add-locations-stepper"
        data-testid="daab-add-locations-stepper"
      >
        <StepWrapper>
          {steps.map((step, i) => {
            const index = i + 1;
            const isLastStep = index === steps.length;
            return (
              <React.Fragment key={index}>
                <Step
                  isActive={activeStep === index}
                  isComplete={activeStep > index}
                  aria-labelledby={`label${index}`}
                  aria-disabled={activeStep < index}
                  aria-controls={`step-content-${index}`}
                  data-testid={`step-buttons-${index}`}
                >
                  <StepIcon
                    dataTestId={`step-${index}-icon`}
                    stepNumber={index}
                  />
                  <StepLabelContainer>
                    <StepPrimaryLabel
                      data-testid={`step-${index}-primary-label`}
                      id={`label${index}`}
                    >
                      <div className="stepper-label">{step.label}</div>
                    </StepPrimaryLabel>
                  </StepLabelContainer>
                </Step>
                {!isLastStep && <StepConnector aria-hidden="true" />}
              </React.Fragment>
            );
          })}
        </StepWrapper>
        <StepProgressBar totalSteps={steps.length} currentStep={activeStep} />
      </StepContainer>
      {steps[activeStep - 1].label ===
        DAAB_ADD_LOCATIONS_STEPS.SELECT_LOCATION && (
        <StepContent>
          <LocationsTable
            selectedApiToManageLocation={selectedAPI}
            handleLocationSelection={handleLocationSelection}
            bundleLocations={bundleLocations}
            bundleId={bundleId}
            activeSubByEntityId={activeSubByEntityId}
            useApiScopedStatus={true}
          />
        </StepContent>
      )}
      {steps[activeStep - 1].label === DAAB_ADD_LOCATIONS_STEPS.SELECT_DMS && (
        <StepContent className="centered-step">
          <SelectDMS
            selectedAPI={selectedAPI}
            handleLocationSelection={handleLocationSelection}
          />
        </StepContent>
      )}
      {steps[activeStep - 1].label ===
        DAAB_ADD_LOCATIONS_STEPS.REVIEW_ACTIVATION && (
        <StepContent>
          <ReviewActivations />
        </StepContent>
      )}
      <StepperFooter
        onNext={() => setActiveStep(activeStep + 1)}
        onPrevious={() => setActiveStep(activeStep - 1)}
        activeStep={activeStep}
        steps={steps}
        onComplete={handleCompleteActivation}
        selectedAPI={selectedAPI}
      />
    </div>
  );
};
